@charset "UTF-8";

/* src/app/components/v2-detail-overlay/v2-detail-overlay.component.scss */
:host {
  display: contents;
}
body.v2-detail-overlay-open {
  overflow: hidden;
}
.v2-detail-overlay {
  position: fixed;
  inset: 0;
  height: 100%;
  max-height: 100dvh;
  z-index: 10050;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  padding-inline: max(0px, (100vw - min(32rem, 100vw)) / 2);
  transform-origin: 50% 50%;
  animation: v2-detail-overlay-enter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
  background: var(--exme-overlay-atmosphere-background);
  --v2-detail-sk-shimmer-base: #cfd6de;
  --v2-detail-sk-shimmer-mid: #e2e8ef;
  --v2-detail-sk-shimmer-hi: #f0f4f8;
}
body.dark .v2-detail-overlay {
  --v2-detail-sk-shimmer-base: #1f2732;
  --v2-detail-sk-shimmer-mid: #2a3442;
  --v2-detail-sk-shimmer-hi: #364353;
}
.v2-detail-overlay.v2-detail-overlay--closing {
  pointer-events: none;
  animation: v2-detail-overlay-exit 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes v2-detail-overlay-enter {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes v2-detail-overlay-exit {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-detail-overlay {
    animation: none;
  }
  .v2-detail-overlay.v2-detail-overlay--closing {
    animation: none;
    opacity: 0;
  }
  .v2-detail-content.v2-detail-content-stage {
    animation: none;
    opacity: 1;
    transform: none;
  }
}
.v2-do-close {
  position: absolute;
  top: 0.65rem;
  right: calc(0.65rem + env(safe-area-inset-right));
  z-index: 60;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  font-family: inherit;
  color: rgba(13, 18, 24, 0.9);
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: scale(1);
  transition: transform 0.12s ease, background 0.12s ease;
}
body.dark .v2-do-close {
  color: rgba(255, 255, 255, 0.92);
  background: rgba(22, 28, 36, 0.9);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}
.v2-do-close:active {
  transform: scale(0.88);
}
body.dark .v2-do-close:active {
  background: rgba(22, 28, 36, 0.98);
}
body:not(.dark) .v2-do-close:active {
  background: rgba(255, 255, 255, 0.88);
}
.v2-do-close:focus-visible {
  outline: 2px solid rgba(13, 18, 24, 0.45);
  outline-offset: 2px;
}
body.dark .v2-do-close:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
}
.v2-detail-overlay--video .v2-do-close {
  z-index: 120;
}
.v2-detail-open-album-btn {
  position: absolute;
  top: 0.65rem;
  left: calc(0.65rem + env(safe-area-inset-left));
  z-index: 60;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-family: inherit;
  color: rgba(13, 18, 24, 0.9);
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: scale(1);
  transition: transform 0.12s ease, background 0.12s ease;
}
.v2-detail-open-album-btn ion-icon {
  font-size: 24px;
}
body.dark .v2-detail-open-album-btn {
  color: rgba(255, 255, 255, 0.95);
  background: rgba(22, 28, 36, 0.9);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}
.v2-detail-open-album-btn:active {
  transform: scale(0.88);
}
body.dark .v2-detail-open-album-btn:active {
  background: rgba(22, 28, 36, 0.98);
}
body:not(.dark) .v2-detail-open-album-btn:active {
  background: rgba(255, 255, 255, 0.88);
}
.v2-detail-open-album-btn:focus-visible {
  outline: 2px solid rgba(13, 18, 24, 0.45);
  outline-offset: 2px;
}
body.dark .v2-detail-open-album-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
}
.v2-detail-swipe-hint {
  position: absolute;
  left: 50%;
  bottom: calc(1.25rem + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  z-index: 58;
  margin: 0;
  padding: 0.45rem 1rem;
  width: min(96vw, 560px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
  text-align: center;
  font-size: 0.82rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(13, 18, 24, 0.88);
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.45);
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.55s ease;
}
body.dark .v2-detail-swipe-hint {
  color: rgba(255, 255, 255, 0.88);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}
.v2-detail-swipe-hint--hide {
  opacity: 0;
}
.v2-detail-swipe-hint__line {
  display: block;
  max-width: 100%;
}
.v2-detail-swipe-hint--stacked {
  bottom: calc(5.5rem + env(safe-area-inset-bottom));
}
.v2-do-title-pill {
  position: absolute;
  top: 1.1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 55;
  width: max-content;
  max-width: min(92vw, 22rem);
  padding: 0.42rem 0.95rem;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.35;
  color: rgba(13, 18, 24, 0.92);
  pointer-events: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(13, 18, 24, 0.07);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
body.dark .v2-do-title-pill {
  color: rgba(255, 255, 255, 0.94);
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
}
.v2-detail-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  padding: 1rem;
  padding-top: 3.5rem;
  padding-bottom: 1.25rem;
  touch-action: none;
  transition: padding 0.6s ease;
}
.v2-detail-content--video {
  padding: 0.35rem 0.5rem;
  padding-top: 3.25rem;
}
.v2-detail-content.v2-detail-content-stage {
  transform-origin: center center;
  animation: v2-detail-card-enter 0.58s cubic-bezier(0.22, 1, 0.36, 1) 0.05s both;
}
@keyframes v2-detail-card-enter {
  from {
    opacity: 0;
    transform: translate3d(0, min(42vh, 500px), 0) scale(0.44);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
.v2-detail-slide-wrap--intro-pending {
  opacity: 0;
  transform: translate3d(0, min(48vh, 520px), 0) scale(0.44);
  transform-origin: center center;
}
@media (prefers-reduced-motion: reduce) {
  .v2-detail-slide-wrap--intro-pending {
    opacity: 1;
    transform: none;
  }
}
.v2-detail-slide-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  max-width: 100%;
  height: 100%;
  touch-action: none;
}
.v2-detail-reel-nav {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  align-self: stretch;
  padding: 0.25rem 0;
}
.v2-reels-root {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  touch-action: none;
  position: relative;
  height: 100%;
}
.v2-reels-track {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.v2-reel {
  flex-shrink: 0;
  width: 100%;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v2-detail-chevron {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(var(--ion-color-text-rgb, 0, 0, 0), 0.06);
  border: none;
  border-radius: 50%;
  color: var(--ion-color-primary);
  cursor: pointer;
}
.v2-detail-chevron ion-icon {
  font-size: 28px;
}
.v2-detail-flip-card {
  position: relative;
  flex: 1;
  max-width: min(650px, 100%);
  max-height: min(500px, 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 2000px;
  cursor: pointer;
  touch-action: none;
}
.v2-detail-flip-card--portrait {
  height: 100%;
  width: auto;
  aspect-ratio: 3/4;
  max-width: 100%;
}
.v2-detail-flip-card--landscape {
  width: 100%;
  height: auto;
  aspect-ratio: 4/3;
}
.v2-detail-flip-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transform: rotateY(0deg);
  transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.v2-detail-flip-no-anim {
  transition: none !important;
}
@media (prefers-reduced-motion: reduce) {
  .v2-detail-flip-inner {
    transition: none;
  }
}
.v2-detail-front,
.v2-detail-back {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  overflow: hidden;
}
.v2-detail-back {
  transform: rotateY(180deg);
}
.v2-detail-back-bg-wrap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.v2-detail-img-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.v2-detail-img-wrap--portrait {
  aspect-ratio: 3/4;
}
.v2-detail-img-wrap--landscape {
  aspect-ratio: 4/3;
}
.v2-detail-img-wrap--missing .v2-detail-img {
  filter: grayscale(100%) blur(5px);
  opacity: 0.82;
}
.v2-detail-loader-wrap {
  position: absolute;
  inset: 1px;
  border-radius: inherit;
  overflow: hidden;
  z-index: 2;
  pointer-events: none;
  background:
    linear-gradient(
      105deg,
      var(--v2-detail-sk-shimmer-base) 0%,
      var(--v2-detail-sk-shimmer-base) 34%,
      var(--v2-detail-sk-shimmer-mid) 44%,
      var(--v2-detail-sk-shimmer-hi) 50%,
      var(--v2-detail-sk-shimmer-mid) 56%,
      var(--v2-detail-sk-shimmer-base) 66%,
      var(--v2-detail-sk-shimmer-base) 100%);
  background-size: 240% 100%;
  animation: v2-detail-sk-shimmer 1.5s ease-in-out infinite;
}
@keyframes v2-detail-sk-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
.v2-detail-img-inner {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v2-detail-img-inner--missing {
  position: relative;
  overflow: hidden;
  border-radius: inherit;
}
.v2-detail-locked-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  pointer-events: none;
}
.v2-detail-locked-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.72);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.v2-detail-locked-icon {
  width: 24px;
  height: 24px;
  color: rgba(255, 255, 255, 0.98);
}
.v2-detail-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.v2-detail-img-fade {
  opacity: 1;
}
.v2-detail-img-missing {
  filter: grayscale(100%) blur(5px);
}
.v2-detail-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.v2-detail-play-btn .v2-detail-play-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.v2-detail-back-bg {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  filter: grayscale(100%);
  background: white;
}
.v2-detail-back .v2-detail-img-wrap {
  overflow: hidden;
}
.v2-detail-back-sized {
  position: relative;
  align-self: center;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: inherit;
}
.v2-detail-back-content {
  position: absolute;
  inset: 0;
  z-index: 2;
  overflow-y: auto;
  scrollbar-width: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 8% 6%;
  -ms-overflow-style: none;
  pointer-events: auto;
}
.v2-detail-back-content::-webkit-scrollbar {
  display: none;
}
.v2-detail-back-svg {
  position: absolute;
  top: -6%;
  width: 80%;
  z-index: 1;
  pointer-events: none;
}
.v2-detail-back-svg--landscape {
  width: 40%;
}
.v2-detail-back-content--landscape .v2-detail-back-label {
  top: 15%;
}
.v2-detail-back-content--landscape .v2-detail-back-label + .v2-detail-back-label {
  top: 23%;
}
.v2-detail-back-content--landscape .v2-detail-back-label + .v2-detail-back-label + .v2-detail-back-label {
  top: 30%;
}
.v2-detail-back-content--landscape .v2-detail-back-desc {
  top: 65%;
}
.v2-detail-back-id {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  font-weight: bold;
  color: black;
  z-index: 2;
}
.v2-detail-back-label {
  position: absolute;
  color: black;
  font-size: calc((1vw + 1vh + 0.5rem) / 1.5);
  font-weight: bold;
  z-index: 2;
}
.v2-detail-back-label-1 {
  top: 22%;
}
.v2-detail-back-label-2 {
  top: 29%;
}
.v2-detail-back-label-3 {
  top: 36%;
}
.v2-detail-back-desc {
  position: absolute;
  top: 62%;
  padding: 0 40px 10px;
  color: black;
  z-index: 2;
}
.v2-detail-back-desc quill-view {
  display: block;
}
.v2-detail-video-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v2-detail-video-loader {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99;
  background: var(--ion-color-mode);
}
.v2-detail-video-loader .loader {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background:
    linear-gradient(
      105deg,
      var(--v2-detail-sk-shimmer-base) 0%,
      var(--v2-detail-sk-shimmer-base) 34%,
      var(--v2-detail-sk-shimmer-mid) 44%,
      var(--v2-detail-sk-shimmer-hi) 50%,
      var(--v2-detail-sk-shimmer-mid) 56%,
      var(--v2-detail-sk-shimmer-base) 66%,
      var(--v2-detail-sk-shimmer-base) 100%);
  background-size: 240% 100%;
  animation: v2-detail-sk-shimmer 1.5s ease-in-out infinite;
}
@media (prefers-reduced-motion: reduce) {
  .v2-detail-loader-wrap,
  .v2-detail-video-loader .loader {
    animation: none;
    background: var(--v2-detail-sk-shimmer-mid);
    background-size: 100% 100%;
  }
}
.v2-detail-video-loader-text {
  margin-top: 20px;
  font-size: 1.1rem;
  font-weight: bold;
  color: var(--ion-color-text);
  animation: v2-detail-loader-text 4s infinite ease-in-out;
}
@keyframes v2-detail-loader-text {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  15% {
    opacity: 0;
    transform: translateY(100%);
  }
  30% {
    opacity: 1;
    transform: translateY(0%);
  }
  60% {
    opacity: 1;
    transform: translateY(0%);
  }
  75% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
.v2-detail-video-stage {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  border-radius: 14px;
  overflow: hidden;
}
.v2-detail-video-stage:fullscreen,
.v2-detail-video-stage:-webkit-full-screen {
  border-radius: 0;
}
.v2-detail-video-stage:fullscreen .v2-detail-video,
.v2-detail-video-stage:-webkit-full-screen .v2-detail-video {
  border-radius: 0;
}
.v2-detail-video-chrome {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 0.4rem 0.5rem calc(0.45rem + env(safe-area-inset-bottom));
  pointer-events: none;
  transition: opacity 0.3s ease;
}
.v2-detail-video-chrome--hidden {
  opacity: 0;
}
.v2-detail-video-chrome__fab {
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(20, 20, 22, 0.78);
  color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.22);
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.72);
  transition: opacity 0.38s cubic-bezier(0.33, 1, 0.68, 1), transform 0.42s cubic-bezier(0.34, 1.45, 0.64, 1);
}
.v2-detail-video-chrome__fab--visible {
  pointer-events: auto;
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}
.v2-detail-video-chrome__fab--visible ion-icon {
  animation: v2-detail-fab-play-in 0.45s cubic-bezier(0.34, 1.45, 0.64, 1) both;
}
.v2-detail-video-chrome__fab ion-icon {
  font-size: 2rem;
  display: block;
}
@keyframes v2-detail-fab-play-in {
  0% {
    transform: scale(0.5);
    opacity: 0.4;
  }
  70% {
    transform: scale(1.08);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.v2-detail-video-chrome__panel {
  pointer-events: auto;
  width: 100%;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.4rem 0.5rem 0.45rem;
  border-radius: 14px;
  background: rgba(12, 12, 14, 0.78);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.22);
}
.v2-detail-video-chrome__unmute-hint {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.45rem;
  padding: 0.38rem 0.45rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.7);
}
.v2-detail-video-chrome__unmute-hint-text {
  flex: 1;
  min-width: 0;
}
.v2-detail-video-chrome__unmute-hint-dismiss {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  margin: -0.1rem -0.15rem 0 0;
  padding: 0;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
}
.v2-detail-video-chrome__unmute-hint-dismiss ion-icon {
  font-size: 1.1rem;
}
.v2-detail-video-chrome__unmute-hint-dismiss:hover,
.v2-detail-video-chrome__unmute-hint-dismiss:focus-visible {
  background: rgba(255, 255, 255, 0.1);
  color: rgb(255, 255, 255);
}
.v2-detail-video-chrome__buffer-track {
  width: 100%;
  height: 3px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  overflow: hidden;
}
.v2-detail-video-chrome__buffer-fill {
  height: 100%;
  min-width: 0;
  border-radius: inherit;
  background:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.35) 0%,
      rgba(255, 255, 255, 0.55) 100%);
  transition: width 0.22s ease-out;
}
.v2-detail-video-chrome__controls {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.35rem;
  min-height: 36px;
}
.v2-detail-video-chrome__controls-spacer {
  flex: 1 1 auto;
  min-width: 0.25rem;
}
.v2-detail-video-chrome__time {
  flex: 0 0 auto;
  font-size: 0.7rem;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.78);
  min-width: 4.75rem;
}
.v2-detail-video-chrome__icon-btn {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.88);
}
.v2-detail-video-chrome__icon-btn ion-icon {
  font-size: 1.2rem;
}
.v2-detail-video-chrome__icon-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}
.v2-detail-video-chrome__icon-btn:active {
  transform: scale(0.97);
}
@media (prefers-reduced-motion: reduce) {
  .v2-detail-video-chrome {
    transition: none;
  }
  .v2-detail-video-chrome__buffer-fill {
    transition: none;
  }
  .v2-detail-video-chrome__fab {
    transition: opacity 0.2s ease;
  }
  .v2-detail-video-chrome__fab--visible ion-icon {
    animation: none;
  }
  .v2-detail-video-chrome__fab--visible {
    transform: translate(-50%, -50%) scale(1);
  }
  .v2-detail-video-chrome__fab:not(.v2-detail-video-chrome__fab--visible) {
    transform: translate(-50%, -50%) scale(1);
  }
}
.v2-detail-video {
  opacity: 0;
  transition: opacity 0.3s ease-in;
  max-height: 100%;
  object-fit: contain;
  border-radius: 14px;
}
.v2-detail-video-fade {
  opacity: 1;
}
.v2-detail-video--landscape {
  width: 100%;
  object-fit: contain;
}
.v2-detail-video--portrait {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.v2-detail-video-error {
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem;
  text-align: center;
  background: var(--ion-color-mode);
}
.v2-detail-video-error-text {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--ion-color-text);
  max-width: 280px;
}
.v2-detail-video-retry {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  border-radius: 14px;
  padding: 12px 20px;
  font-weight: 700;
  font-family:
    "Signika",
    system-ui,
    sans-serif;
  cursor: pointer;
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast, #fff);
}
@media (prefers-reduced-motion: reduce) {
  .v2-detail-video-loader .loader {
    animation: none !important;
  }
  .v2-detail-video-loader-text {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}
@keyframes v2-detail-morph-request-col-expand {
  from {
    max-width: 0;
    opacity: 0;
  }
  to {
    max-width: calc((100% - 0.65rem) / 2);
    opacity: 1;
  }
}
@keyframes v2-detail-morph-request-col-collapse-from-orange {
  from {
    max-width: calc((100% - 0.65rem) / 2);
    opacity: 1;
  }
  to {
    max-width: 0;
    opacity: 0;
  }
}
@keyframes v2-detail-morph-request-fade {
  0%, 32% {
    opacity: 0;
  }
  55%, 100% {
    opacity: 1;
  }
}
@keyframes v2-detail-morph-swap-scale {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0.96);
  }
}
@keyframes v2-detail-morph-swap-scale-reverse {
  from {
    transform: scale(0.96);
  }
  to {
    transform: scale(1);
  }
}
.v2-detail-footer {
  flex-shrink: 0;
  max-height: 320px;
  padding: 0 0.65rem;
  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom));
  padding-left: calc(0.65rem + env(safe-area-inset-left));
  padding-right: calc(0.65rem + env(safe-area-inset-right));
  background: transparent;
  transition:
    padding 0.6s ease,
    opacity 0.6s ease,
    max-height 0.6s ease;
}
.v2-detail-footer-inner {
  position: relative;
  overflow: hidden;
  padding: 0.85rem 1rem 1rem;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.07);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(100%) scale(0);
  transform-origin: 50% 100%;
  transition: transform 0.6s ease;
}
body.dark .v2-detail-footer-inner {
  background: rgba(22, 28, 36, 0.7);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
}
.v2-detail-footer-inner.opened.loaded {
  transform: translateY(0) scale(1);
}
.v2-detail-footer--video-mode {
  max-height: 0;
  padding: 0 !important;
  margin: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}
.v2-detail-footer .v2-detail-footer-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 0.65rem;
  width: 100%;
  max-width: 100%;
  margin: 0;
  position: relative;
  z-index: 1;
}
.v2-detail-footer .v2-detail-footer-morph,
.v2-detail-footer .v2-detail-footer-morph-reverse {
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 0rem;
}
.v2-detail-footer-request-col,
.v2-detail-footer-swap-col {
  flex: 1 1 0%;
  min-width: 0;
}
.v2-detail-footer-swap-col {
  display: flex;
  flex-direction: column;
}
.v2-detail-footer .v2-detail-footer-morph .v2-detail-footer-request-col {
  overflow: hidden;
  animation: v2-detail-morph-request-col-expand 0.72s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.v2-detail-footer-morph-reverse:not(.v2-detail-footer-morph-reverse--from-orange) .v2-detail-footer-request-col {
  flex: 0 0 0%;
  max-width: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}
.v2-detail-footer .v2-detail-footer-morph-reverse--from-orange .v2-detail-footer-request-col {
  overflow: hidden;
  pointer-events: none;
  animation: v2-detail-morph-request-col-collapse-from-orange 0.72s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}
.v2-detail-footer .v2-detail-morph-request {
  min-width: 0;
  overflow: hidden;
  opacity: 0;
  animation: v2-detail-morph-request-fade 0.72s ease both;
}
.v2-detail-footer .v2-detail-morph-swap {
  min-width: 0;
  animation: v2-detail-morph-swap-scale 0.72s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.v2-detail-footer app-btn.v2-detail-footer-btn--request-collapsed {
  opacity: 0;
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
.v2-detail-footer .v2-detail-morph-swap-alone {
  min-width: 0;
  width: 100%;
  max-width: 100%;
  margin-inline: 0;
  animation: v2-detail-morph-swap-scale-reverse 0.72s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.v2-detail-footer .v2-detail-footer-morph app-btn.v2-detail-footer-btn {
  min-width: 0;
}
.v2-detail-footer app-btn.v2-detail-footer-btn {
  display: block;
  width: 100%;
  margin: 0;
}
.v2-detail-footer app-btn.v2-detail-footer-btn ::ng-deep .btn-wrapper {
  width: 100%;
  display: block;
}
.v2-detail-footer app-btn.v2-detail-footer-btn ::ng-deep .btn {
  width: 100%;
  min-height: 48px;
  border-radius: 16px;
  padding: 14px 16px;
  font-size: 0.95rem;
  font-weight: 700;
  font-family:
    "Signika",
    system-ui,
    sans-serif;
  letter-spacing: 0.02em;
  text-transform: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.18s ease, filter 0.18s ease;
}
.v2-detail-footer app-btn.v2-detail-footer-btn ::ng-deep .btn ion-icon {
  font-size: 1.2rem;
  margin-inline-end: 4px;
}
.v2-detail-footer app-btn.v2-detail-footer-btn ::ng-deep .btn:active {
  transform: scale(0.98);
}
.v2-detail-footer app-btn.v2-detail-footer-btn--request ::ng-deep .btn,
.v2-detail-footer app-btn.v2-detail-footer-btn--swap ::ng-deep .btn {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.14);
}
@media (prefers-reduced-motion: reduce) {
  .v2-detail-header-wrapper,
  .v2-detail-header,
  .v2-detail-content,
  .v2-detail-footer,
  .v2-detail-footer-inner {
    transition: none !important;
  }
  .v2-detail-footer,
  .v2-detail-footer .v2-detail-footer-morph,
  .v2-detail-footer .v2-detail-footer-morph-reverse,
  .v2-detail-footer .v2-detail-morph-request,
  .v2-detail-footer .v2-detail-morph-swap,
  .v2-detail-footer .v2-detail-morph-swap-alone {
    animation: none !important;
  }
  .v2-detail-footer .v2-detail-footer-morph .v2-detail-footer-request-col {
    max-width: calc((100% - 0.65rem) / 2);
    opacity: 1;
  }
  .v2-detail-footer .v2-detail-morph-request {
    opacity: 1;
  }
  .v2-detail-footer .v2-detail-morph-swap {
    transform: none;
  }
  .v2-detail-footer .v2-detail-footer-morph-reverse .v2-detail-footer-request-col,
  .v2-detail-footer .v2-detail-footer-morph-reverse--from-orange .v2-detail-footer-request-col {
    flex: 0 0 0%;
    max-width: 0;
    opacity: 0;
    animation: none !important;
  }
  .v2-detail-footer .v2-detail-morph-swap-alone {
    transform: none;
  }
}
/*# sourceMappingURL=v2-detail-overlay.component.css.map */
